import { DEFAULT_LOCALE_ID, LocaleId } from '@portfolio/configs'
import { groq } from 'next-sanity'
import { createLinkProjection } from './createLinkProjection'
import { createSanityColorProjection } from './createSanityColorProjecton'

export const createRichTextProjection = (
  localeId: LocaleId,
  defaultLocaleId = DEFAULT_LOCALE_ID,
) => {
  const LINK_PROJECTION = createLinkProjection(localeId, defaultLocaleId)
  const COLOR_PROJECTION = createSanityColorProjection()

  return groq`{
    ...,
    markDefs[]{
      ...,
      _type == "link" => {
        _key,
        _type,
        ...${LINK_PROJECTION},
      },
      _type == "textColor" => {
        _key,
        _type,
        color${COLOR_PROJECTION},
      }
    },
  }`
}
